import React from "react";
import { DatePicker, TimePicker } from "@toddle-edu/ds-web";
import { DATE_TIME_CONSTANTS } from "Constants/dateTimeConstants";
import classes from "./DateTime.scss";
import { useDateTime } from "../../hooks";
import {
  mapStateToProps,
  mapActionCreators,
  addTimeToDate,
} from "../../modules/Utils";
import { connect } from "react-redux";
import classNames from "classnames";
import {
  getSelectedAcademicYearIdForSchool,
  getSelectedSchoolDetailsForCalendar,
} from "MyCalendar/modules/Utils";

const TimeBasedInput = props => {
  const {
    minDate,
    maxDate,
    onStartDateChange,
    testId,
    t,
    startDate,
    endDate,
    showBorder,
    dateContainerClass,
  } = props;

  const { setEventEndDate, setEventStartDate } = useDateTime(props);
  const onDateChange = date => {
    const updatedStartDate = addTimeToDate(date, startDate);
    setEventStartDate(updatedStartDate);

    // Clone the date and update time with endDate's time for end date
    const updatedEndDate = addTimeToDate(date, endDate);

    setEventEndDate(updatedEndDate);
  };

  const onEndTimeChangeLocalHandler = date => {
    const updatedStartDate = addTimeToDate(startDate, date);
    setEventEndDate(updatedStartDate);
  };

  const onStartTimeChangeLocalHandler = date => {
    const updatedStartDate = addTimeToDate(startDate, date);
    onStartDateChange(updatedStartDate);
  };

  const startTimePickerClass = classNames({
    [classes.starttimePicker]: !showBorder,
    [classes.starttimePickerV2]: showBorder,
  });
  const endTimePickerClass = classNames({
    [classes.endtimePicker]: !showBorder,
    [classes.endtimePickerV2]: showBorder,
  });

  const dashClasses = classNames({
    [classes.dash]: !showBorder,
    [classes.dashV2]: showBorder,
  });

  return (
    <div className={classes.timePickerContainer}>
      <div className={classNames(classes.datePicker, dateContainerClass)}>
        <DatePicker
          size="medium"
          variant={showBorder ? "outlined" : "inline"}
          placeholder={t("common:start_date")}
          format={DATE_TIME_CONSTANTS.ddd_DD_MMM_YYYY}
          value={startDate}
          onChange={onDateChange}
          minDate={minDate}
          maxDate={maxDate}
          showTimePicker={false}
          testId={`${testId}-start-date`}
          showIcon={false}
        />
      </div>
      <div className={startTimePickerClass}>
        <TimePicker
          placeholder={t("common:start_time")}
          onChange={onStartTimeChangeLocalHandler}
          value={startDate?.clone()}
          testId={"start-time-picker"}
          dsVersion="2.0"
          showTimePicker={true}
          showIcon={false}
        />
      </div>
      <div className={classNames("text-body", dashClasses)}>-</div>
      <div className={endTimePickerClass}>
        <TimePicker
          placeholder={t("common:end_time")}
          onChange={onEndTimeChangeLocalHandler}
          value={endDate?.clone()}
          minTime={startDate?.clone()?.add(15, "minutes")}
          testId={"end-time-picker"}
          dsVersion="2.0"
          showTimePicker={true}
          showIcon={false}
        />
      </div>
    </div>
  );
};

const localMapStateToProps = state => {
  const {
    currentCurriculumProgramId: curriculumProgramId,
  } = getSelectedSchoolDetailsForCalendar(state);
  const currentAcademicYearId = getSelectedAcademicYearIdForSchool(state);
  return {
    ...mapStateToProps(state),
    curriculumProgramId,
    currentAcademicYearId,
  };
};

export default connect(localMapStateToProps, mapActionCreators)(TimeBasedInput);
